export const toTruckDetailPayload = (values, id) => ({
  documentList: values.documentList,
  id: +id,
  driverAssisted: values.driverConform.find(item => item.value === 'DRIVER_ASSISTED')
    ? true
    : false,
  driverEquipped: values.driverConform.find(item => item.value === 'DRIVER_EQUIPPED')
    ? true
    : false,
  sealList: values.sealList,
  temperature: values.temperature,
  thermodiagramConform: values.thermodiagramConform,
  driverName: values.driverName
})
